<template>
  <div class="scan">
    <!--   谈宝头部-->
    <div class="scan-header">
      <i></i>
      <span class="scan-title">谈宝</span>
      <!--    顶部Tab-->
      <div class="tabbar">
        <Tab :navbarList="navbarList" showNab="1"></Tab>
      </div>
    </div>

    <!--    谈宝主体-->
    <div class="container">
      <router-view></router-view>
    </div>
    <!--    发布谈宝内容-->
    <van-popup v-model="showPublish" round position="bottom" :style="{ height: '25%' }">
      <ul class="publish-content">
        <li @click="cancelPublish('发布图片')">发布图片</li>
        <li @click="cancelPublish('发布视频')">发布视频</li>
        <li @click="cancelPublish">取消</li>
      </ul>
    </van-popup>
    <!--    视频播放-->
    <van-overlay :show="showVideo">
      <div class="wrapper">
        <div class="block">
          <div class="back-icon">
            <van-icon name="arrow-left" color="#ffffff" size="0.4rem" @click="closeVideo" />
          </div>
          <video class="videoStyle" ref="pauseVideo" controls :src="filterImg" autoplay="autoplay"></video>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import api from '../../utils/api'
import { aGet, aPost } from '../../utils/request'
import $ from 'jquery'
import Tab from '../../components/Tab/Tab'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    Tab: Tab
  },
  data() {
    return {
      navbarList: [
        { typeName: '谈宝', path: '/scan' },
        { typeName: '游戏', path: '/Game' },
        { typeName: '直播', path: 'Live' }
      ],
      showPublish: false,
      showVideo: false,
      filterImg: ''
    }
  },
  methods: {
    ...mapActions(['setShowPublish', 'setVideoSrc', 'setVideoShow']),
    //是否发布谈宝内容
    cancelPublish(value) {
      if (value === '发布视频') {
        this.$router.push({ name: 'publish', params: { name: value } })
      } else if (value === '发布图片') {
        this.$router.push({ name: 'publishimg', params: { name: value } })
      }
      this.setShowPublish(false)
    },
    //关闭视频
    closeVideo() {
      // console.log(this.$refs.pauseVideo);
      this.$refs.pauseVideo.pause()
      this.showVideo = false
    }
  },
  computed: {
    ...mapGetters(['getShowPublish', 'getVideoSrc', 'getVideoShow']),
    bmTab() {
      return this.$store.state.bmTab
    }
  },
  watch: {
    //关闭发布
    showPublish(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setShowPublish(newValue)
      }
    },
    //打开发布
    getShowPublish(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.showPublish = newValue
      }
    },
    //打開视频
    getVideoShow(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.showVideo = newValue
        this.filterImg = this.getVideoSrc
      }
    },
    //关闭视频
    showVideo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setVideoShow(newValue)
      }
    }
  },
  created() {
    this.$store.state.bmTab = 3
  },

  mounted() {
    // this.aboutValuda();
  },
  updated() {}
}
</script>

<style scoped lang="scss">
@import '../../assets/mixin';
.scan {
  background: #ffffff;
  width: 100%;
  height: 100%;
  //头部
  .scan-header {
    width: 100%;
    height: 86px;
    padding: 30px 0 16px 32px;
    background-color: #ffffff;
    position: fixed;
    top: 54px;
    left: 0;
    i {
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url('../../assets/img/baby/talk-baby.png') center center no-repeat;
      background-size: contain;
      vertical-align: -6px;
      margin-right: 16px;
    }
    span {
      display: inline-block;
      font-size: 34px;
      color: #dc6a2b;
      line-height: 34px;
      font-weight: bold;
    }
    //顶部Tab
    .tabbar {
      width: 100%;
      margin-top: 18px;
      background-color: #ffffff;
      //padding: 0 32px;
    }
  }
  //内容区域
  .container {
    width: 100%;
    padding: 0 32px;
    height: calc(100% - 94px - 142px - 100px);
    position: fixed;
    left: 0;
    top: 236px;
  }
  //发布内容
  .publish-content {
    width: 100%;
    padding: 0 24px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    li {
      width: 100%;
      height: 104px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 104px;
      text-align: center;
      font-size: 32px;
      color: #222222;
      &:last-child {
        border: none;
      }
    }
  }
  /deep/ .van-overlay {
    z-index: 12;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 100%;
      height: 100%;
      .back-icon {
        width: 100%;
        height: 96px;
        padding: 0 20px;
        background-color: #000;
        position: relative;
        /deep/ .van-icon {
          position: absolute !important;
          top: 80px;
          transform: translateY(-50%);
        }
      }
      .videoStyle {
        width: 100%;
        height: calc(100% - 96px);
        background-color: #000000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/scan/scan.vue